import { api } from './api';

const getFaceValues = async ({customerId}) => {
    const response = await api({
        url: `OrderFaceValues/getbycustomerid`,
        method: 'GET',
        params: {
            customerId,
        },
    });
    return response.data;
};

const faceValuesSave = async (data) => {
    const response = await api({
        url: `OrderFaceValues/add`,
        method: 'POST',
        data: data.entity,
    });
    return response.data;
};

const faceValuePopupServices = {
  getFaceValues,
  faceValuesSave,
};

export default faceValuePopupServices;
